import React, { useState } from 'react';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import DataGrid from './DataGrid';
import { DataGridColDef } from './DataGrid/DataGrid';
import {
  PropElementResponse,
  PropElemScheduleResponse,
} from '../services/proposal';
import { toCurrency } from '../utils/utils';
import { isNil } from 'lodash';
import _ from 'lodash';
import { Row, Spin, Switch, Typography } from 'antd';
import moment from 'moment';
import ModalControllerNV from './ModalControllerNV';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import GetLabel from 'DisplayFramework/components/GetLabel';

export type FinancialScheduleTableProps = {
  allElements: any;
  currcode?: string;
  loading?: boolean;
  flagretailer?: boolean;
};
const { Text } = Typography;

const FinancialScheduleTable = (props: FinancialScheduleTableProps) => {
  const { allElements, currcode, loading, flagretailer } = props;
  const [merge, setmerge] = useState(false);
  const FIN = (allElements.FIN as PropElementResponse[]) ?? [];
  const SERV = (allElements.SERV as PropElementResponse[]) ?? [];
  const FEES = (allElements.FEES as PropElementResponse[]) ?? [];
  const FINSERV = (allElements.FINSERV as PropElementResponse[]) ?? [];

  let mergedElementsSchedules: any = [];
  const data = FIN.map((elem) => {
    const servsch: any = SERV.filter(
      (ele: any) => ele.cteidparent === elem.cteid && ele.ctedirection === 'IN'
    ).map((serv) => {
      return {
        schedule: serv.conElemSchedules,
        name: serv.ctedescription,
      };
    });
    const feessch: any = FEES.filter(
      (ele: any) => ele.cteidparent === elem.cteid && ele.ctedirection === 'IN'
    ).map((serv) => {
      return {
        schedule: serv.conElemSchedules,
        name: serv.ctedescription,
      };
    });
    const finservsch: any = FINSERV.filter(
      (ele: any) => ele.cteidparent === elem.cteid
    ).map((serv) => {
      return {
        schedule: serv.conElemSchedules,
        name: serv.ctedescription,
      };
    });
    const getSchAmount = (
      sch: Array<PropElemScheduleResponse>,
      duedate: string,
      ctstype: string
    ) => {
      let amount = 0;
      if (sch && sch.length > 0) {
        sch.forEach((e: any) => {
          if (
            String(e.ctsduedate) === String(duedate) &&
            e.ctsstatus !== 'CANCEL'
          ) {
            amount = e.ctsrentalamount;
          }
        });
      }

      return amount;
    };

    let ScheduleNotInRangeOfFin: any = [];
    let currentDate = '';
    let firstDateIteration = 0;
    const FirstLineFinSch = elem.conElemSchedules[0];

    let newObj = {
      serv1: 0,
      serv2: 0,
      serv3: 0,
      serv4: 0,
      fees1: 0,
      fees2: 0,
      fees3: 0,
      fees4: 0,
      finserv1: 0,
      finserv2: 0,
      finserv3: 0,
      finserv4: 0,
      finserv5: 0,
      finserv6: 0,
      ctsduedate: '',
      ctsrentalincDeposit: 0,
      ctstype: 'RENTAL',
    };

    let firstDate = servsch[0]?.schedule[0]?.ctsduedate;

    if (firstDate === undefined) {
      firstDate = feessch[0]?.schedule[0]?.ctsduedate;
    }

    const getLowestDate = (datetocompare: string) => {
      let date = datetocompare;
      servsch.forEach((serv: any) => {
        serv.schedule.forEach((schedLine: any) => {
          if (
            String(schedLine.ctsduedate) < String(date) &&
            ScheduleNotInRangeOfFin.find(
              (ele: any) => ele.ctsduedate === schedLine.ctsduedate
            ) === undefined &&
            schedLine.ctsduedate <= FirstLineFinSch?.ctsduedate
          )
            date = schedLine.ctsduedate;
        });
      });
      feessch.forEach((serv: any) => {
        serv.schedule.forEach((schedLine: any) => {
          if (
            String(schedLine.ctsduedate) < String(date) &&
            ScheduleNotInRangeOfFin.find(
              (ele: any) => ele.ctsduedate === schedLine.ctsduedate
            ) === undefined &&
            schedLine.ctsduedate <= FirstLineFinSch?.ctsduedate
          )
            date = schedLine.ctsduedate;
        });
      });
      finservsch.forEach((serv: any) => {
        serv.schedule.forEach((schedLine: any) => {
          if (
            String(schedLine.ctsduedate) < String(date) &&
            ScheduleNotInRangeOfFin.find(
              (ele: any) => ele.ctsduedate === schedLine.ctsduedate
            ) === undefined &&
            schedLine.ctsduedate <= FirstLineFinSch?.ctsduedate
          )
            date = schedLine.ctsduedate;
        });
      });

      if (
        (date === datetocompare && firstDate !== date) ||
        firstDateIteration === 1
      )
        return '';
      else if (currentDate === date) {
        firstDateIteration = 1;
        return date;
      } else return date;
    };

    currentDate = getLowestDate(servsch[0]?.schedule[0]?.ctsduedate);

    if (currentDate === '') {
      currentDate = getLowestDate(feessch[0]?.schedule[0]?.ctsduedate);
    }

    while (currentDate !== '') {
      let test = 0;

      servsch[0]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.serv1 = sched.ctsrentalamount;
        }
      });

      servsch[1]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.serv2 = sched.ctsrentalamount;
        }
      });

      servsch[2]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.serv3 = sched.ctsrentalamount;
        }
      });

      servsch[3]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.serv4 = sched.ctsrentalamount;
        }
      });

      feessch[0]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.fees1 = sched.ctsrentalamount;
        }
      });

      feessch[1]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.fees2 = sched.ctsrentalamount;
        }
      });

      feessch[2]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.fees3 = sched.ctsrentalamount;
        }
      });
      feessch[3]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.fees4 = sched.ctsrentalamount;
        }
      });

      finservsch[0]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.finserv1 = sched.ctsrentalamount;
        }
      });

      finservsch[1]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.finserv2 = sched.ctsrentalamount;
        }
      });
      finservsch[2]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.finserv3 = sched.ctsrentalamount;
        }
      });
      finservsch[3]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.finserv4 = sched.ctsrentalamount;
        }
      });
      finservsch[4]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.finserv5 = sched.ctsrentalamount;
        }
      });
      finservsch[5]?.schedule.forEach((sched: any) => {
        if (
          String(sched?.ctsduedate) === currentDate &&
          !isNil(sched?.ctsduedate)
        ) {
          test = 1;
          newObj.finserv6 = sched.ctsrentalamount;
        }
      });

      if (
        test === 1 &&
        getLowestDate(FirstLineFinSch?.ctsduedate) >= currentDate
      ) {
        newObj.ctsduedate = currentDate;
        newObj.ctsrentalincDeposit =
          newObj.serv1 +
          newObj.serv2 +
          newObj.serv3 +
          newObj.serv4 +
          newObj.fees1 +
          newObj.fees2 +
          newObj.fees3 +
          newObj.fees4 +
          newObj.finserv1 +
          newObj.finserv2 +
          newObj.finserv3 +
          newObj.finserv4 +
          newObj.finserv5 +
          newObj.finserv6;
        ScheduleNotInRangeOfFin.push(newObj);
      }

      newObj = {
        serv1: 0,
        serv2: 0,
        serv3: 0,
        serv4: 0,
        fees1: 0,
        fees2: 0,
        fees3: 0,
        fees4: 0,
        finserv1: 0,
        finserv2: 0,
        finserv3: 0,
        finserv4: 0,
        finserv5: 0,
        finserv6: 0,
        ctsrentalincDeposit: 0,
        ctsduedate: '',
        ctstype: 'RENTAL',
      };
      currentDate = getLowestDate(FirstLineFinSch?.ctsduedate);
      test = 0;
    }

    const newSchedule = [...(elem?.conElemSchedules ?? [])].map((el, index) => {
      let ctstypeOK =
        el.ctstype === 'RENTAL' ||
        el.ctstype === 'FIRSTRENT' ||
        el.ctstype === 'UPFRONT' ||
        el.ctstype === 'GRACE';
      return {
        serv1: ctstypeOK
          ? getSchAmount(servsch[0]?.schedule, el.ctsduedate, el.ctstype)
          : 0,
        serv2: ctstypeOK
          ? getSchAmount(servsch[1]?.schedule, el.ctsduedate, el.ctstype)
          : 0,
        serv3: ctstypeOK
          ? getSchAmount(servsch[2]?.schedule, el.ctsduedate, el.ctstype)
          : 0,
        serv4: ctstypeOK
          ? getSchAmount(servsch[3]?.schedule, el.ctsduedate, el.ctstype)
          : 0,
        fees1: ctstypeOK
          ? getSchAmount(feessch[0]?.schedule, el.ctsduedate, el.ctstype)
          : 0,
        fees2: ctstypeOK
          ? getSchAmount(feessch[1]?.schedule, el.ctsduedate, el.ctstype)
          : 0,

        fees3: ctstypeOK
          ? getSchAmount(feessch[2]?.schedule, el.ctsduedate, el.ctstype)
          : 0,

        fees4: ctstypeOK
          ? getSchAmount(feessch[3]?.schedule, el.ctsduedate, el.ctstype)
          : 0,
        finserv1: getSchAmount(
          finservsch[0]?.schedule,
          el.ctsduedate,
          el.ctstype
        ),

        finserv2: getSchAmount(
          finservsch[1]?.schedule,
          el.ctsduedate,
          el.ctstype
        ),
        finserv3: getSchAmount(
          finservsch[2]?.schedule,
          el.ctsduedate,
          el.ctstype
        ),
        finserv4: getSchAmount(
          finservsch[3]?.schedule,
          el.ctsduedate,
          el.ctstype
        ),
        finserv5: getSchAmount(
          finservsch[4]?.schedule,
          el.ctsduedate,
          el.ctstype
        ),
        finserv6: getSchAmount(
          finservsch[5]?.schedule,
          el.ctsduedate,
          el.ctstype
        ),

        ctsrentalincDeposit:
          el.ctsrentalamount -
          el.ctsdepositinterest +
          (ctstypeOK
            ? getSchAmount(servsch[0]?.schedule, el.ctsduedate, el.ctstype)
            : 0) +
          (ctstypeOK
            ? getSchAmount(servsch[1]?.schedule, el.ctsduedate, el.ctstype)
            : 0) +
          (ctstypeOK
            ? getSchAmount(servsch[2]?.schedule, el.ctsduedate, el.ctstype)
            : 0) +
          (ctstypeOK
            ? getSchAmount(servsch[3]?.schedule, el.ctsduedate, el.ctstype)
            : 0) +
          (ctstypeOK
            ? getSchAmount(feessch[0]?.schedule, el.ctsduedate, el.ctstype)
            : 0) +
          (ctstypeOK
            ? getSchAmount(feessch[1]?.schedule, el.ctsduedate, el.ctstype)
            : 0) +
          (ctstypeOK
            ? getSchAmount(feessch[2]?.schedule, el.ctsduedate, el.ctstype)
            : 0) +
          (ctstypeOK
            ? getSchAmount(feessch[3]?.schedule, el.ctsduedate, el.ctstype)
            : 0) +
          getSchAmount(finservsch[0]?.schedule, el.ctsduedate, el.ctstype) +
          getSchAmount(finservsch[1]?.schedule, el.ctsduedate, el.ctstype) +
          getSchAmount(finservsch[2]?.schedule, el.ctsduedate, el.ctstype) +
          getSchAmount(finservsch[3]?.schedule, el.ctsduedate, el.ctstype) +
          getSchAmount(finservsch[4]?.schedule, el.ctsduedate, el.ctstype) +
          getSchAmount(finservsch[5]?.schedule, el.ctsduedate, el.ctstype),
        ...el,
      };
    });
    const newnewSchedule = ScheduleNotInRangeOfFin.concat(newSchedule);
    mergedElementsSchedules = mergedElementsSchedules.concat(newSchedule);

    return {
      ctsdepositinterest: _.sumBy(newnewSchedule, 'ctsdepositinterest'),
      ctsrentalincDeposit: _.sumBy(newnewSchedule, 'ctsrentalincDeposit'),
      ctsrentalamount: _.sumBy(newnewSchedule, 'ctsrentalamount'),
      ctsinterestamount: _.sumBy(newnewSchedule, 'ctsinterestamount'),
      ctsamortizedamount: _.sumBy(newnewSchedule, 'ctsamortizedamount'),
      serv1: _.sumBy(newnewSchedule, 'serv1'),
      serv1name: servsch[0]?.name,
      serv2: _.sumBy(newnewSchedule, 'serv2'),
      serv2name: servsch[1]?.name,
      serv3: _.sumBy(newnewSchedule, 'serv3'),
      serv3name: servsch[2]?.name,
      serv4: _.sumBy(newnewSchedule, 'serv4'),
      serv4name: servsch[3]?.name,
      fees1: _.sumBy(newnewSchedule, 'fees1'),
      fees1name: feessch[0]?.name,
      fees2name: feessch[1]?.name,
      fees3name: feessch[2]?.name,
      fees4name: feessch[3]?.name,
      finserv1name: finservsch[0]?.name,
      finserv2name: finservsch[1]?.name,
      finserv3name: finservsch[2]?.name,
      finserv4name: finservsch[3]?.name,
      finserv5name: finservsch[4]?.name,
      finserv6name: finservsch[5]?.name,
      fees2: _.sumBy(newnewSchedule, 'fees2'),
      fees3: _.sumBy(newnewSchedule, 'fees3'),
      fees4: _.sumBy(newnewSchedule, 'fees4'),
      finserv1: _.sumBy(newnewSchedule, 'finserv1'),
      finserv2: _.sumBy(newnewSchedule, 'finserv2'),
      finserv3: _.sumBy(newnewSchedule, 'finserv3'),
      finserv4: _.sumBy(newnewSchedule, 'finserv4'),
      finserv5: _.sumBy(newnewSchedule, 'finserv5'),
      finserv6: _.sumBy(newnewSchedule, 'finserv6'),
      ctedescription: elem.ctedescription,
      cteid: elem.cteid,
      children: newnewSchedule,
    };
  });


  let res = _.orderBy(
    mergedElementsSchedules,
    ['ctsduedate', 'ctstype'],
    ['asc', 'asc']
  );

  res = res.map((elm, index) => ({ ...elm, ctsorder: index + 1 }));

  res.unshift({
    ctsdepositinterest: _.sumBy(mergedElementsSchedules, 'ctsdepositinterest'),
    ctsrentalincDeposit: _.sumBy(
      mergedElementsSchedules,
      'ctsrentalincDeposit'
    ),
    ctsinterestamount: _.sumBy(mergedElementsSchedules, 'ctsinterestamount'),
    ctsamortizedamount: _.sumBy(mergedElementsSchedules, 'ctsamortizedamount'),
    ctsrentalamount: _.sumBy(mergedElementsSchedules, 'ctsrentalamount'),
    serv1: _.sumBy(mergedElementsSchedules, 'serv1'),
    serv2: _.sumBy(mergedElementsSchedules, 'serv2'),
    serv3: _.sumBy(mergedElementsSchedules, 'serv3'),
    serv4: _.sumBy(mergedElementsSchedules, 'serv4'),
    fees1: _.sumBy(mergedElementsSchedules, 'fees1'),
    fees2: _.sumBy(mergedElementsSchedules, 'fees2'),
    fees3: _.sumBy(mergedElementsSchedules, 'fees3'),
    fees4: _.sumBy(mergedElementsSchedules, 'fees4'),
    finserv1: _.sumBy(mergedElementsSchedules, 'finserv1'),
    finserv2: _.sumBy(mergedElementsSchedules, 'finserv2'),
    finserv3: _.sumBy(mergedElementsSchedules, 'finserv3'),
    finserv4: _.sumBy(mergedElementsSchedules, 'finserv4'),
    finserv5: _.sumBy(mergedElementsSchedules, 'finserv5'),
    finserv6: _.sumBy(mergedElementsSchedules, 'finserv6'),

    ctsorder: 'total',
  });

  const filterColumns = () => {
    let filteredColumns = COLUMNS;
    if (merge) {
      filteredColumns = COLUMNS.filter((e) => e.dataIndex !== 'ctedescription');
    }
    if (data.every((el) => el.serv1name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'serv1');
    }
    if (data.every((el) => el.serv2name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'serv2');
    }
    if (data.every((el) => el.serv3name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'serv3');
    }
    if (data.every((el) => el.serv4name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'serv4');
    }
    if (data.every((el) => el.fees1name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'fees1');
    }
    if (data.every((el) => el.fees2name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'fees2');
    }
    if (data.every((el) => el.fees3name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'fees3');
    }
    if (data.every((el) => el.fees4name === undefined)) {
      filteredColumns = filteredColumns.filter((e) => e.dataIndex !== 'fees4');
    }
    if (data.every((el) => el.finserv1name === undefined)) {
      filteredColumns = filteredColumns.filter(
        (e) => e.dataIndex !== 'finserv1'
      );
    }
    if (data.every((el) => el.finserv2name === undefined)) {
      filteredColumns = filteredColumns.filter(
        (e) => e.dataIndex !== 'finserv2'
      );
    }
    if (data.every((el) => el.finserv3name === undefined)) {
      filteredColumns = filteredColumns.filter(
        (e) => e.dataIndex !== 'finserv3'
      );
    }
    if (data.every((el) => el.finserv4name === undefined)) {
      filteredColumns = filteredColumns.filter(
        (e) => e.dataIndex !== 'finserv4'
      );
    }
    if (data.every((el) => el.finserv5name === undefined)) {
      filteredColumns = filteredColumns.filter(
        (e) => e.dataIndex !== 'finserv5'
      );
    }
    if (data.every((el) => el.finserv6name === undefined)) {
      filteredColumns = filteredColumns.filter(
        (e) => e.dataIndex !== 'finserv6'
      );
    }

    return filteredColumns;
  };
  const COLUMNS: DataGridColDef<PropElemScheduleResponse>[] = [
    {
      comcode: 'PaymentSchedule.ctedescription',
      dataIndex: 'ctedescription',
      fixed: 'left',
      width: 250,
    },
    {
      comcode: 'PaymentSchedule.ctsorder',
      dataIndex: 'ctsorder',
      render: (val) =>
        val === 'total' ? (
          <Text type="danger" strong>
            Total
          </Text>
        ) : (
          val
        ),
      width: 80,
    },
    {
      comcode: 'PaymentSchedule.ctstype',
      dataIndex: 'ctstype',
      width: 100,
      render: (val) =>
        flagretailer && val === 'RENTAL'
          ? 'GRACE'
          : flagretailer && val === 'RV'
          ? 'CAPITAL'
          : val,
    },
    {
      comcode: 'PaymentSchedule.ctsduedate',
      dataIndex: 'ctsduedate',
      sorter: {
        compare: (a: any, b: any) =>
          moment(a.ctsduedate) > moment(b.ctsduedate) ? 1 : -1,
        multiple: 3,
      },
      width: 100,
    },
    {
      align: 'right',
      comcode: 'PaymentSchedule.ctsstartamount',
      dataIndex: 'ctsstartamount',
      render: (value, record: any) =>
        record.ctedescription === undefined && record.ctsorder !== 'total'
          ? toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )
          : null,
      width: 100,
    },
    {
      align: 'right',
      comcode: 'PaymentSchedule.ctsamortizedamount',
      dataIndex: 'ctsamortizedamount',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          toCurrency(value, currcode ?? localStorage.getItem('currcode') ?? '')
        ),

      width: 100,
    },
    {
      align: 'right',
      comcode: 'PaymentSchedule.ctsinterestamount',
      dataIndex: 'ctsinterestamount',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          toCurrency(value, currcode ?? localStorage.getItem('currcode') ?? '')
        ),
      width: 100,
    },
    {
      align: 'right',
      comcode: 'PaymentSchedule.ctsrentalamount',
      dataIndex: 'ctsrentalamount',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text type="warning">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
    {
      align: 'right',
      comcode: 'psTable.ctsdepositinterest',
      dataIndex: 'ctsdepositinterest',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              -value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          toCurrency(-value, currcode ?? localStorage.getItem('currcode') ?? '')
        ),
      width: 100,
    },
    {
      align: 'right',
      title: `${data.find((el) => !isNil(el.serv1name))?.serv1name}`,
      dataIndex: 'serv1',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
    {
      align: 'right',
      title: `${data.find((el) => !isNil(el.serv2name))?.serv2name}`,
      dataIndex: 'serv2',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
    {
      align: 'right',
      title: `${data.find((el) => !isNil(el.serv3name))?.serv3name}`,
      dataIndex: 'serv3',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
    {
      align: 'right',
      title: `${data.find((el) => !isNil(el.serv4name))?.serv4name}`,
      dataIndex: 'serv4',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },

    {
      align: 'right',
      title: `${data[0]?.fees1name}`,
      dataIndex: 'fees1',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.fees2name}`,
      dataIndex: 'fees2',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },

    {
      align: 'right',
      title: `${data[0]?.fees3name}`,
      dataIndex: 'fees3',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.fees4name}`,
      dataIndex: 'fees4',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.finserv1name}`,
      dataIndex: 'finserv1',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.finserv2name}`,
      dataIndex: 'finserv2',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.finserv3name}`,
      dataIndex: 'finserv3',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.finserv4name}`,
      dataIndex: 'finserv4',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.finserv5name}`,
      dataIndex: 'finserv5',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
    {
      align: 'right',
      title: `${data[0]?.finserv6name}`,
      dataIndex: 'finserv6',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
    {
      comcode: 'PaymentSchedule.ctsstatus',
      dataIndex: 'ctsstatus',
      width: 100,
      fixed: 'right',
    },
    {
      comcode: 'PaymentSchedule.cireference',
      dataIndex: 'cireference',
      render: (value, record) => {
        return (
          <ModalControllerNV
            modal={({ setVisible, visible }) => (
              <CIDetail
                ciid={record.ciid}
                onCancel={() => setVisible(false)}
                showAsModal
                visible={visible}
                showButtons={false}
              />
            )}
            content={({ setVisible, visible }) => (
              <a onClick={() => setVisible(true)}>{value}</a>
            )}
          />
        );
      },
      width: 150,
      fixed: 'right',
    },

    {
      align: 'right',
      comcode: 'psTable.ctsrentalincDeposit',
      key: 'ctsrentalincDeposit',
      dataIndex: 'ctsrentalincDeposit',
      fixed: 'right',
      render: (value, record: any) =>
        record.ctedescription !== undefined || record.ctsorder === 'total' ? (
          <Text type="danger">
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ) : (
          <Text strong={value > 0 ? true : false}>
            {toCurrency(
              value,
              currcode ?? localStorage.getItem('currcode') ?? ''
            )}
          </Text>
        ),
      width: 100,
    },
  ];

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Spin spinning={!res ?? loading}>
        <Row>
          <GetLabel label="Merge Financial Elements ?" /> &nbsp;
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            onChange={(e) => (e === true ? setmerge(true) : setmerge(false))}
          />
        </Row>
        <div>
          <DataGrid
            dataSource={merge ? res : data ?? []}
            columns={filterColumns()}
            rowKey={(record) => record.ctsid}
            scroll={{ x: 1000, y: 360 }}
            pagination={{ pageSize: 200, hideOnSinglePage: true }}
            bordered
            extractData="paymentSchedule"
            extraActions
            hideMarginExtractData
          />
        </div>
      </Spin>
    </div>
  );
};

export default FinancialScheduleTable;
